var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDriveIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 0.333252H2.66634C1.38301 0.333252 0.333008 1.38325 0.333008 2.66659V21.3333C0.333008 22.6166 1.38301 23.6666 2.66634 23.6666H21.333C22.6163 23.6666 23.6663 22.6166 23.6663 21.3333V2.66659C23.6663 1.38325 22.6163 0.333252 21.333 0.333252ZM21.333 21.3333H2.66634V2.66659H21.333V21.3333Z",
    fill: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49967 14.3333C9.14401 14.3333 9.66634 13.8109 9.66634 13.1666C9.66634 12.5223 9.14401 11.9999 8.49967 11.9999C7.85534 11.9999 7.33301 12.5223 7.33301 13.1666C7.33301 13.8109 7.85534 14.3333 8.49967 14.3333Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4997 14.3333C16.144 14.3333 16.6663 13.8109 16.6663 13.1666C16.6663 12.5223 16.144 11.9999 15.4997 11.9999C14.8553 11.9999 14.333 12.5223 14.333 13.1666C14.333 13.8109 14.8553 14.3333 15.4997 14.3333Z",
    fill: "#C0C0C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74301 19.5833H5.25634C5.75801 19.5833 6.16634 19.1633 6.16634 18.6383V17.2499H17.833V18.6383C17.833 19.1633 18.2297 19.5833 18.743 19.5833H19.2563C19.758 19.5833 20.1663 19.1633 20.1663 18.6383V11.0549C19.2097 8.18492 18.603 6.35325 18.3463 5.58325C18.288 5.39659 18.2063 5.24492 18.1247 5.11659C18.1013 5.09325 18.0897 5.06992 18.0663 5.03492C17.623 4.42825 16.993 4.41659 16.993 4.41659H7.00634C7.00634 4.41659 6.37634 4.42825 5.93301 5.04659C5.90968 5.06992 5.89801 5.09325 5.87467 5.11659C5.79301 5.24492 5.71134 5.39659 5.65301 5.58325C5.39634 6.35325 4.78967 8.17325 3.83301 11.0549V18.6383C3.83301 19.1633 4.24134 19.5833 4.74301 19.5833ZM7.71801 6.74992H16.2813L16.5497 7.55492L17.0513 9.08325H6.94801L7.71801 6.74992ZM6.16634 11.4166H17.833V14.9166H6.16634V11.4166Z",
    fill: "#C0C0C0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveIn);
export default __webpack_public_path__ + "static/media/driveIn.ea1eacf05bb080aa1ee6a832dcae1d14.svg";
export { ForwardRef as ReactComponent };